import { useQuery } from '@apollo/client';
import {
  ContentRepositoriesRes,
  ContentRepository,
  GET_CONTENT_REPOSITORIES,
} from '../../../../../apollo/queries/organisations/contentRepositores.queries';

interface UseContentRepositoriesResponse {
  loading: boolean;
  contentRepositories: ContentRepository[];
}

const useContentRepositoriesAPI = (): UseContentRepositoriesResponse => {
  const { loading, data } = useQuery<ContentRepositoriesRes>(
    GET_CONTENT_REPOSITORIES,
  );

  return {
    loading,
    contentRepositories: (data && data.allContentRepositories) || [],
  };
};

export default useContentRepositoriesAPI;
